import pimg1 from '../images/projects/1.jpg'
import pimg2 from '../images/projects/2.jpg'
import pimg3 from '../images/projects/3.jpg'
import pimg4 from '../images/projects/14.jpg'
import pimg5 from '../images/projects/4.jpg'
import pimg6 from '../images/projects/5.jpg'
import pimg7 from '../images/projects/6.jpg'
import pimg8 from '../images/projects/7.jpg'
import pimg9 from '../images/projects/8.jpg'
import pimg10 from '../images/projects/9.jpg'
import pimg11 from '../images/projects/10.jpg'
import pimg12 from '../images/projects/11.jpg'
import pimg13 from '../images/projects/12.jpg'
import pimg14 from '../images/projects/13.jpg'

import ps1img1 from '../images/project-single/1.jpg'
import ps1img2 from '../images/project-single/2.jpg'
import ps1img3 from '../images/project-single/3.jpg'
import ps1img4 from '../images/project-single/4.jpg'
import ps1img5 from '../images/project-single/5.jpg'
import ps1img6 from '../images/project-single/6.jpg'
import ps1img7 from '../images/project-single/7.jpg'
import ps1img8 from '../images/project-single/8.jpg'
import ps1img9 from '../images/project-single/9.jpg'
import ps1img10 from '../images/project-single/11.jpg'
import ps1img11 from '../images/project-single/10.jpg'
import ps1img12 from '../images/project-single/12.jpg'
import ps1img13 from '../images/project-single/13.jpg'
import ps1img14 from '../images/project-single/14.jpg'


import psub1img1 from '../images/project-single/p1.jpg'
import psub1img2 from '../images/project-single/p2.jpg'


const Projects = [
    {
       Id:'1',
       pImg:pimg1,
       ps1img:ps1img1,
       psub1img1:psub1img1,
       psub1img2:psub1img2,
       title:'Architecture',  
       subTitle:'Architecture Design',   
    },
    {
       Id:'2',
       pImg:pimg2,
       ps1img:ps1img2,
       psub1img1:psub1img1,
       psub1img2:psub1img2,
       title:'Interior', 
       subTitle:'Interior Design',    
    },
    {
      Id:'3',
      pImg:pimg3,
      ps1img:ps1img3,
      psub1img1:psub1img1,
      psub1img2:psub1img2,
      title:'Architecture',  
      subTitle:'Architecture Design',   
   },
    {
       Id:'4',
       pImg:pimg4,
       ps1img:ps1img4,
       psub1img1:psub1img1,
       psub1img2:psub1img2,
       title:'Architecture',  
       subTitle:'Architecture Design', 
    },
    {
       Id:'5',
       pImg:pimg5,
       ps1img:ps1img5,
       psub1img1:psub1img1,
       psub1img2:psub1img2,
       title:'Architecture',  
       subTitle:'Architecture Design',   
    },
    {
       Id:'6',
       pImg:pimg6,
       ps1img:ps1img6,
       psub1img1:psub1img1,
       psub1img2:psub1img2,
       title:'Interior', 
       subTitle:'Interior Design',    
    },
    {
      Id:'7',
      pImg:pimg7,
      ps1img:ps1img7,
      psub1img1:psub1img1,
      psub1img2:psub1img2,
      title:'Interior', 
      subTitle:'Interior Design',  
   },
    {
       Id:'8',
       pImg:pimg8,
       ps1img:ps1img8,
       psub1img1:psub1img1,
       psub1img2:psub1img2,
       title:'Interior', 
       subTitle:'Interior Design',
    },
    {
       Id:'9',
       pImg:pimg9,
       ps1img:ps1img9,
       psub1img1:psub1img1,
       psub1img2:psub1img2,
       title:'Architecture',  
      subTitle:'Architecture Design', 
    },
    {
      Id:'10',
      pImg:pimg1,
      ps1img:ps1img1,
      psub1img1:psub1img1,
      psub1img2:psub1img2,
      title:'Architecture',  
      subTitle:'Architecture Design',   
   },
   {
      Id:'11',
      pImg:pimg2,
      ps1img:ps1img2,
      psub1img1:psub1img1,
      psub1img2:psub1img2,
      title:'Interior', 
      subTitle:'Interior Design',    
   },
   {
     Id:'12',
     pImg:pimg3,
     ps1img:ps1img3,
     psub1img1:psub1img1,
     psub1img2:psub1img2,
     title:'Architecture',  
     subTitle:'Architecture Design',   
  },
   {
     Id:'13',
     pImg:pimg10,
     ps1img:ps1img10,
     psub1img1:psub1img1,
     psub1img2:psub1img2,
     title:'Architecture',  
     subTitle:'Architecture Design',   
  },
   {
     Id:'14',
     pImg:pimg11,
     ps1img:ps1img11,
     psub1img1:psub1img1,
     psub1img2:psub1img2,
     title:'Architecture',  
     subTitle:'Architecture Design',   
  },
   {
     Id:'15',
     pImg:pimg12,
     ps1img:ps1img12,
     psub1img1:psub1img1,
     psub1img2:psub1img2,
     title:'Architecture',  
     subTitle:'Architecture Design',   
  },
   {
     Id:'16',
     pImg:pimg13,
     ps1img:ps1img13,
     psub1img1:psub1img1,
     psub1img2:psub1img2,
     title:'Architecture',  
     subTitle:'Architecture Design',   
  },
   {
     Id:'17',
     pImg:pimg14,
     ps1img:ps1img14,
     psub1img1:psub1img1,
     psub1img2:psub1img2,
     title:'Architecture',  
     subTitle:'Architecture Design',   
  },
   {
     Id:'18',
     pImg:pimg13,
     ps1img:ps1img13,
     psub1img1:psub1img1,
     psub1img2:psub1img2,
     title:'Architecture',  
     subTitle:'Architecture Design',    
  },
    
]

export default Projects;